import { ContentAuthorData } from 'components/AlchemyContent/types/author'
import React from 'react'
import styled from 'styled-components'
import Text from 'UIKit/Text'
import { formatDisplayDate } from 'utils/dateHelper'
import ContentBlockContainer from '../ContentBlockContainer'

interface AuthorDataProps {
  data: ContentAuthorData
}

const AuthorContent: React.FC<AuthorDataProps> = ({ data: { alignment, createdTime, name } }) => {
  return (
    <ContentBlockContainer
      my="1px"
      alignItems="center"
      justifyContent={alignment === 'left' ? 'flex-start' : alignment === 'right' ? 'flex-end' : alignment}
    >
      <StyledName>{name}</StyledName>
      <StyledCreatedTime>{formatDisplayDate(new Date(createdTime * 1000))}</StyledCreatedTime>
    </ContentBlockContainer>
  )
}

const StyledName = styled(Text)`
  color: rgba(255, 255, 255, 0.81);
  line-height: normal;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: -0.32px;
  padding-right: 8px;
  border-right: 2px solid rgba(255, 255, 255, 0.13);
`

const StyledCreatedTime = styled(Text)`
  color: rgba(255, 255, 255, 0.81);
  line-height: normal;
  font-size: 14px;
  letter-spacing: -0.32px;
  padding-left: 8px;
`

export default AuthorContent
